export const API_VERSION = 'v2';
export const PROMOTION_URL = `${API_VERSION}/banners`;
export const PLAYLIST_URL = `${API_VERSION}/homepage_playlists`;
